import technologiesURL from "../../../../../docs/assets/technologies.jpg";
import APIHandlerURL from "../../../../../docs/assets/api-handler.jpg";
import * as React from 'react';
export default {
  technologiesURL,
  APIHandlerURL,
  React
};